import React from "react";

function Project({ image, name, description, url }) {
  return (
    <div className="project">
      <div className="project_image">
        {" "}
        <a href={url} rel="noreferrer" target="_blank">
          <img src={image} alt="project " />
        </a>
      </div>
      <div className="project_info">
        <a href={url} rel="noreferrer" target="_blank">
          <h1>{name}</h1>
        </a>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default Project;
